import { useMutation } from '@tanstack/react-query';
import { deletePerformer } from './deletePerformer';
import { invalidateLocalContentPerformers } from '../collection/product/useLocalContentPerformers';
import { useTranslation } from 'react-i18next';
import { showNotification } from '../../../shared/notification/toastNotification';

export const useDeletePerformer = () => {
    const { t } = useTranslation();
    return useMutation(deletePerformer, {
        onSuccess: () => {
            showNotification(t('notifications.useDeletePerformer.success'));
            invalidateLocalContentPerformers().then();
        }
    });
};
